import { render, staticRenderFns } from "./r-item-deprecate-mode.vue?vue&type=template&id=1b5aa4c2"
import script from "./r-item-deprecate-mode.vue?vue&type=script&lang=js"
export * from "./r-item-deprecate-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5aa4c2')) {
      api.createRecord('1b5aa4c2', component.options)
    } else {
      api.reload('1b5aa4c2', component.options)
    }
    module.hot.accept("./r-item-deprecate-mode.vue?vue&type=template&id=1b5aa4c2", function () {
      api.rerender('1b5aa4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/deprecate/r-item-deprecate-mode.vue"
export default component.exports